export default __webpack_public_path__ + "static/mssql-9a72b4c0f712ee18cc8de95bbd9d942d.svg";